<h2 mat-dialog-title>{{formTitle}}</h2>
<p-toast appendTo="body"></p-toast>

<p-dialog header="Uploading..." [(visible)]="uploadingDialog" [modal]="true" [closable]="false" [style]="{width:'320px'}">
  <p style="margin:0">Uploading {{ uploadingCount }} file(s) — please wait...</p>
</p-dialog>

<mat-dialog-content>
  <form [formGroup]="form1">

    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label">Content Type *</label>
        <select class="form-select" formControlName="contentTypeId">
          @for (ct of contentTypes; track ct.contentTypeId) {
            <option [ngValue]="ct.contentTypeId">{{ct.name}}</option>
          }
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label">Category <span class="text-muted" style="font-size:85%">(optional)</span></label>
        <input class="form-control" formControlName="category" placeholder="e.g. newsletter, guide">
      </div>
      <div class="col-md-4">
        <label class="form-label">Status *</label>
        <select class="form-select" formControlName="status">
          @for (s of statuses; track s) {
            <option [value]="s.value">{{s.name}}</option>
          }
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <label class="form-label">Title *</label>
        <input class="form-control" formControlName="title" (blur)="isNew ? autoSlug() : null">
        @if (form1.get('title')?.invalid && form1.get('title')?.touched) {
          <div class="text-danger small">
            Title is required (min 3 characters).
          </div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-8">
        <label class="form-label">URL Slug</label>
        <input class="form-control" formControlName="slug" placeholder="auto-generated-from-title">
      </div>
      <div class="col-md-4">
        <label class="form-label">Schema Type</label>
        <select class="form-select" formControlName="schemaType">
          <option [ngValue]="null">None</option>
          <option value="Article">Article</option>
          <option value="FAQPage">FAQPage</option>
          <option value="BlogPosting">BlogPosting</option>
          <option value="HowTo">HowTo</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <label class="form-label">Summary</label>
        <textarea class="form-control" formControlName="summary" rows="2" maxlength="500"></textarea>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <label class="form-label">Body HTML</label>
        @if (!contentLoaded) {
          <div class="p-2 text-muted small">Loading editor...</div>
        }
        @if (contentLoaded) {
          <editor
            formControlName="bodyHtml"
            [init]="tinyMceInit">
          </editor>
        }
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label">Meta Title (SEO)</label>
        <input class="form-control" formControlName="metaTitle" maxlength="200">
      </div>
      <div class="col-md-6">
        <label class="form-label">Meta Description (SEO)</label>
        <input class="form-control" formControlName="metaDescription" maxlength="200">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <label class="form-label">Keywords (SEO)</label>
        <input class="form-control" formControlName="keywords" maxlength="500">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-3">
        <label class="form-label">Location</label>
        <p-dropdown [options]="locations" formControlName="locationId"
          optionLabel="locationName" optionValue="locationId"
          placeholder="All Locations" [showClear]="true" [filter]="true" filterBy="locationName"
          [style]="{'width':'100%'}" appendTo="body"></p-dropdown>
      </div>
      <div class="col-md-3">
        <label class="form-label">Property</label>
        <p-dropdown [options]="properties" formControlName="shortTermRentalId"
          optionLabel="propertyCode" optionValue="shortTermRentalId"
          placeholder="All Properties" [showClear]="true" [filter]="true" filterBy="propertyCode"
          [style]="{'width':'100%'}" appendTo="body"></p-dropdown>
      </div>
      <div class="col-md-3">
        <label class="form-label">Developments</label>
        <p-multiSelect [options]="developments" formControlName="developmentIds"
          optionLabel="displayName" optionValue="developmentId"
          defaultLabel="Select Developments" [showClear]="true" [filter]="true" filterBy="displayName"
          [style]="{'width':'100%'}" appendTo="body" [maxSelectedLabels]="2"
          selectedItemsLabel="{0} selected"></p-multiSelect>
      </div>
      <div class="col-md-3">
        <label class="form-label">ADR Region</label>
        <p-dropdown [options]="adrRegions" formControlName="adrRegion"
          optionLabel="label" optionValue="value"
          placeholder="All Regions" [showClear]="true" [filter]="true" filterBy="label"
          [editable]="true" [style]="{'width':'100%'}" appendTo="body"></p-dropdown>
      </div>
    </div>

    @if (form1.get('contentTypeId')?.value === 2) {
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="form-label">Statement Month (MM/YYYY) <span class="text-danger">*</span></label>
          <input class="form-control" formControlName="statementMonth" placeholder="e.g. 04/2026"
            [class.is-invalid]="form1.get('statementMonth')?.invalid && (form1.get('statementMonth')?.dirty || form1.get('statementMonth')?.touched)">
          @if (form1.get('statementMonth')?.invalid && (form1.get('statementMonth')?.dirty || form1.get('statementMonth')?.touched)) {
            <div class="invalid-feedback d-block">
              @if (form1.get('statementMonth')?.errors?.['required']) {
                Statement Month is required for Statement Letter content. Enter MM/YYYY (e.g. 04/2026).
              } @else if (form1.get('statementMonth')?.errors?.['pattern']) {
                Must be MM/YYYY format with a zero-padded month (e.g. 04/2026, not 4/2026).
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="row mb-3">
      <div class="col-md-3">
        <label class="form-label">Sort Order</label>
        <input class="form-control" formControlName="sortOrder" type="number">
      </div>
      <div class="col-md-3">
        <label class="form-label">Generated By</label>
        <input class="form-control" formControlName="generatedBy">
      </div>
      <div class="col-md-3">
        <label class="form-label">Enabled</label>
        <select class="form-select" formControlName="enabled">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Featured</label>
        <select class="form-select" formControlName="featured">
          <option [ngValue]="false">No</option>
          <option [ngValue]="true">Yes</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label">Scheduled Publish Date</label>
        <input class="form-control" formControlName="scheduledPublishDate" type="datetime-local"
               title="Leave blank to publish manually. When set, the nightly job will auto-publish at this time.">
      </div>
    </div>

    @if (form1.get('contentTypeId')?.value === 4) {
      <div class="row mb-3">
        <div class="col-md-12">
          <label class="form-label">FAQ Items</label>
          @for (faq of faqList; track faq; let i = $index) {
            <div class="faq-row"
                 [class.faq-img-drag]="faqDragOverIndex === i"
                 (dragover)="faqImageDragOver($event, i)"
                 (dragleave)="faqImageDragLeave()"
                 (drop)="faqImageDrop($event, i)"
                 (paste)="faqImagePaste($event, i)"
                 tabindex="0">
              <div class="faq-row-header">
                <span class="faq-row-num">{{ i + 1 }}</span>
                <button type="button" class="faq-remove-btn" (click)="faqRemove(i)" title="Remove row">&#10005;</button>
              </div>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label class="form-label">Section</label>
                  <input class="form-control form-control-sm" [(ngModel)]="faq.sectionName" [ngModelOptions]="{standalone: true}" placeholder="Optional section heading">
                </div>
                <div class="col-md-3 mb-2">
                  <label class="form-label">Order</label>
                  <input class="form-control form-control-sm" [(ngModel)]="faq.displayOrder" [ngModelOptions]="{standalone: true}" type="number">
                </div>
                <div class="col-md-3 mb-2">
                  <label class="form-label">Enabled</label>
                  <select class="form-select form-select-sm" [(ngModel)]="faq.enabled" [ngModelOptions]="{standalone: true}">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-2">
                  <label class="form-label">Question</label>
                  <input class="form-control form-control-sm" [(ngModel)]="faq.questionDesc" [ngModelOptions]="{standalone: true}">
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-2">
                  <label class="form-label">Answer</label>
                  <textarea class="form-control form-control-sm" [(ngModel)]="faq.answerDesc" [ngModelOptions]="{standalone: true}" rows="3"></textarea>
                </div>
              </div>
              <div class="faq-img-slot">
                @if (!faq.imageUrl) {
                  <input type="file" accept="image/*" style="display:none" #faqFileInput (change)="faqImageSelect(i, $event)">
                  <button type="button" class="faq-img-add-btn" (click)="faqFileInput.click()">+ Add image</button>
                }
                @if (faq.imageUrl) {
                  <div class="faq-img-wrap">
                    <img [src]="faq.imageUrl" class="faq-thumb" alt="">
                    <button type="button" class="faq-img-clear-btn" (click)="faqImageClear(i)" title="Remove image">&#10005;</button>
                  </div>
                }
              </div>
            </div>
          }
          <button type="button" class="faq-add-row-btn" (click)="faqAdd()">+ Add FAQ row</button>
        </div>
      </div>
    }

    <div class="row mb-3">
      <div class="col-md-12">
        <label class="form-label">Media</label>
        <app-media-tab [(mediaList)]="mediaList"></app-media-tab>
      </div>
    </div>

    @if (!isNew) {
      <!-- Feature #14: Workflow -->
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="d-flex align-items-center gap-2 mb-2">
            <strong>Workflow:</strong>
            <span class="badge" [ngClass]="{'bg-secondary': form1.get('status')?.value === 'DRAFT', 'bg-warning text-dark': form1.get('status')?.value === 'REVIEW', 'bg-info text-dark': form1.get('status')?.value === 'APPROVED', 'bg-success': form1.get('status')?.value === 'PUBLISHED', 'bg-dark': form1.get('status')?.value === 'ARCHIVED'}">
              {{form1.get('status')?.value}}
            </span>
          </div>
          <div class="d-flex gap-2 flex-wrap">
            @if (form1.get('status')?.value === 'DRAFT') {
              <button pButton pRipple type="button" class="p-button-warning p-button-sm" label="Submit for Review"
                [disabled]="workflowLoading" (click)="initiateWorkflowTransition('REVIEW')"></button>
              <button pButton pRipple type="button" class="p-button-success p-button-sm" label="Publish Now"
                [disabled]="workflowLoading || formLoading" (click)="publishNow()"></button>
            }
            @if (form1.get('status')?.value === 'REVIEW') {
              <button pButton pRipple type="button" class="p-button-success p-button-sm" label="Approve"
                [disabled]="workflowLoading" (click)="initiateWorkflowTransition('APPROVED')"></button>
              <button pButton pRipple type="button" class="p-button-danger p-button-sm" label="Reject"
                [disabled]="workflowLoading" (click)="initiateWorkflowTransition('DRAFT')"></button>
            }
            @if (form1.get('status')?.value === 'APPROVED') {
              <button pButton pRipple type="button" class="p-button-success p-button-sm" label="Publish"
                [disabled]="workflowLoading" (click)="initiateWorkflowTransition('PUBLISHED')"></button>
            }
          </div>
        </div>
      </div>

      <!-- Feature #17: Autolink Suggestions -->
      @if (autolinkSuggestions.length > 0) {
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="d-flex align-items-center gap-2 mb-2">
              <strong>Link Suggestions</strong>
              <span class="badge bg-warning text-dark">{{autolinkSuggestions.length}}</span>
              <button pButton pRipple type="button" class="p-button-text p-button-sm"
                [label]="showAutolinkPanel ? 'Hide' : 'Show'"
                (click)="showAutolinkPanel = !showAutolinkPanel"></button>
            </div>
            @if (showAutolinkPanel) {
              <div class="border rounded p-2">
                @for (s of autolinkSuggestions; track s.suggestionId) {
                  <div class="d-flex align-items-center justify-content-between py-1 border-bottom">
                    <span class="small">Match: <em>"{{s.matchText}}"</em> &rarr; <strong>{{s.suggestedLinkLabel}}</strong> <span class="text-muted">({{s.linkType}})</span></span>
                    <div class="d-flex gap-1">
                      <button pButton pRipple type="button" class="p-button-success p-button-sm" label="Apply" (click)="applyAutolinkSuggestion(s)"></button>
                      <button pButton pRipple type="button" class="p-button-text p-button-sm" label="Dismiss" (click)="dismissAutolinkSuggestion(s)"></button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }

      <!-- Feature #10: Revision History -->
      <div class="row mb-3">
        <div class="col-md-12">
          <button pButton pRipple type="button" class="p-button-text p-button-sm"
            [label]="showRevisions ? 'Hide Revision History' : 'Revision History'"
            icon="pi pi-history" (click)="toggleRevisions()"></button>
          @if (showRevisions) {
            <div class="mt-2">
              @if (revisionsLoading) {
                <p-progressSpinner [style]="{'width':'32px','height':'32px'}"></p-progressSpinner>
              }
              @if (!revisionsLoading) {
                <p-table [value]="revisions" [rows]="10" styleClass="p-datatable-sm p-datatable-striped">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width:60px">#</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Summary</th>
                      <th style="width:80px"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rev>
                    <tr>
                      <td>{{rev.revisionNum}}</td>
                      <td>{{rev.changeDate | date:'MM/dd/yyyy HH:mm'}}</td>
                      <td>{{rev.status}}</td>
                      <td>{{rev.changeSummary}}</td>
                      <td>
                        <button pButton pRipple type="button" class="p-button-warning p-button-sm" label="Restore"
                          (click)="revertToRevision(rev.revisionId)"></button>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr><td colspan="5">No revisions found.</td></tr>
                  </ng-template>
                </p-table>
              }
            </div>
          }
        </div>
      </div>
    }

  </form>
</mat-dialog-content>

<!-- Feature #14: Workflow comment dialog -->
<p-dialog header="Add Comment" [(visible)]="showWorkflowComment" [modal]="true" [style]="{width:'420px'}" [closable]="true">
  <div class="mb-3">
    <label class="form-label">Transition to: <strong>{{workflowTargetStatus}}</strong></label>
    <textarea class="form-control mt-2" [(ngModel)]="workflowComment" rows="3" placeholder="Optional comment..."></textarea>
  </div>
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" class="p-button-text" label="Cancel" (click)="showWorkflowComment = false"></button>
    <button pButton pRipple type="button" class="p-button-primary" label="Confirm" (click)="confirmWorkflowTransition()"></button>
  </ng-template>
</p-dialog>

<!-- Feature #12: Entity Picker dialog -->
<p-dialog header="Insert Link" [(visible)]="showEntityPicker" [modal]="true" [style]="{width:'540px'}" [closable]="true">
  <p-tabView [(activeIndex)]="entityPickerTabIndex" (onChange)="entityPickerSearch = ''">
    <p-tabPanel header="Guides"></p-tabPanel>
    <p-tabPanel header="FAQs"></p-tabPanel>
  </p-tabView>
  <div class="mb-2 mt-2">
    <input pInputText class="form-control" [(ngModel)]="entityPickerSearch" placeholder="Search by title...">
  </div>
  @if (entityPickerLoading) {
    <p-progressSpinner [style]="{'width':'32px','height':'32px'}"></p-progressSpinner>
  }
  <ul class="list-group" style="max-height:300px;overflow-y:auto;">
    @for (item of getFilteredEntityItems(); track item.contentId) {
      <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          style="cursor:pointer" (click)="insertEntityLink(item)">
        <span>{{item.title}}</span>
        <span class="text-muted small">/{{entityPickerTabIndex === 0 ? 'guides' : 'faqs'}}/{{item.slug}}</span>
      </li>
    }
    @if (getFilteredEntityItems().length === 0 && !entityPickerLoading) {
      <li class="list-group-item text-muted">No results.</li>
    }
  </ul>
</p-dialog>

<mat-dialog-actions align="end">
  @if (!isNew) {
    <button mat-raised-button color="warn" (click)="formDelete()" [disabled]="formLoading" style="margin-right: auto;">Delete</button>
  }
  @if (!isNew && form1.get('slug')?.value) {
    <a mat-button target="_blank"
       [href]="'https://www.kbmresorts.com/guides/' + form1.get('slug')?.value"
       style="margin-right: 8px;">Preview</a>
  }
  <button mat-button mat-dialog-close>Cancel</button>
  @if (isNew) {
    <button mat-raised-button color="primary" (click)="formAdd()" [disabled]="formLoading">Save</button>
  }
  @if (!isNew) {
    <button mat-raised-button color="primary" (click)="formUpdate()" [disabled]="formLoading">Save Changes</button>
  }
</mat-dialog-actions>
